/**
 * Ist das Geraet gerade online?
 *
 * Fuer die Verwaltung (ADR 0006): Benutzer und Stammdaten werden nur mit Netz
 * gepflegt. Ohne Netz sind die Knoepfe gesperrt und sagen, warum -- statt dass
 * eine Aenderung scheinbar klappt und spaeter verschwindet.
 */

import { useSyncExternalStore } from "react";

export function useOnline(): boolean {
  return useSyncExternalStore(
    (b) => {
      globalThis.addEventListener("online", b);
      globalThis.addEventListener("offline", b);
      return () => {
        globalThis.removeEventListener("online", b);
        globalThis.removeEventListener("offline", b);
      };
    },
    () => globalThis.navigator.onLine,
  );
}
